import React, { ReactNode } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ErrorBoundary } from '../../../../components/common/ErrorBoundary'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { ViewBase } from '../../../../components/common/ViewBase'
import { ErrorView } from '../../../error/ErrorView'
import { IllustrationChoices } from '../../../../components/common/Illustration'
import { useCurrentSociety } from '../../../../hooks/useCurrentSociety'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../../navigation/reverseDocumentTitle'
import { Linkify } from '../../../../components/common/Linkify'
import { widgetQueries } from '../../../../api/society-widgets'

export const WidgetView = (): ReactNode => {
  const { translate } = useAppTranslation()
  const { widgetId } = useParams()
  const { society } = useCurrentSociety()

  const { data: widget } = useQuery(widgetQueries.getWidget(widgetId))

  useDocumentTitle(
    reverseDocumentTitle('society:widgets-detail', {
      '{{ societyName }}': society?.name,
      '{{ widgetName }}': widget?.title,
    })
  )

  return (
    <ErrorBoundary>
      <ViewBase title={widget?.title || ''}>
        {widget ? (
          <Linkify>
            <p className="whitespace-pre-line">{widget.content}</p>
          </Linkify>
        ) : (
          <ErrorView
            title={translate('widgetView.emptyState.title')}
            subtitle={translate('widgetView.emptyState.subtitle')}
            illustration={IllustrationChoices.EMPTY}
          />
        )}
      </ViewBase>
    </ErrorBoundary>
  )
}
